import { observer } from "mobx-react-lite";
import { useVideoStore } from "../../../../../../../../shared/hooks/useVideoStore";

export const StoryboardStrip = observer(() => {
    const videoStore = useVideoStore();
    const { frames, activeFrameIndex } = videoStore;

    if (frames.length === 0) return null;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
                padding: "1rem",
                background: "rgba(15, 23, 42, 0.9)",
                borderRadius: "8px",
                maxWidth: "100%",
            }}
            role="region"
            aria-label="Video storyboard"
        >
            {/* Active frame enlarged above */}
            <div
                style={{
                    width: "160px",
                    height: "90px",
                    background: `url(${frames[activeFrameIndex]?.imageData})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "8px",
                    border: "3px solid #3b82f6",
                    boxShadow: "0 8px 24px rgba(59, 130, 246, 0.5)",
                    transition: "all 0.3s ease",
                }}
                aria-label={`Active frame at ${frames[activeFrameIndex]?.timestamp.toFixed(1)}s`}
            />

            {/* Stacked frame strip */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    height: "60px",
                    overflowX: "auto",
                    padding: "0 1rem",
                }}
            >
                {frames.map((frame, index) => (
                    <div
                        key={index}
                        style={{
                            width: "80px",
                            height: "45px",
                            background: `url(${frame.imageData})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: "4px",
                            cursor: "pointer",
                            border:
                                index === activeFrameIndex
                                    ? "2px solid #3b82f6"
                                    : "1px solid #334155",
                            marginLeft: index === 0 ? "0" : "-20px",
                            transition: "all 0.2s ease",
                            zIndex:
                                index === activeFrameIndex
                                    ? 10
                                    : frames.length - index,
                            flexShrink: 0,
                            opacity: index === activeFrameIndex ? 1 : 0.7,
                        }}
                        onClick={() => videoStore.seekToFrame(index)}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                                "scale(1.1) translateY(-5px)";
                            e.currentTarget.style.zIndex = "20";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform =
                                "scale(1) translateY(0)";
                            e.currentTarget.style.zIndex =
                                index === activeFrameIndex
                                    ? "10"
                                    : `${frames.length - index}`;
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label={`Seek to ${frame.timestamp.toFixed(1)} seconds`}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                videoStore.seekToFrame(index);
                            }
                        }}
                    />
                ))}
            </div>
        </div>
    );
});
